import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=4d413d43&scoped=true"
import script from "./BasicModal.vue?vue&type=script&lang=js"
export * from "./BasicModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.vue?vue&type=style&index=0&id=4d413d43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d413d43",
  null
  
)

export default component.exports